import React from 'react';
import ProgramCutators from "../../components/program_curtators/ProgramCurtators";

const Founders = () => {
  return (
    <ProgramCutators />
  )
}

export default Founders